import matter from 'gray-matter'
import Post from '../../src/components/BlogPost'
import { getHeroContent, sortByDate, usePagination } from '../../src/utils/helpers'
import {
  Box, Container, Typography,
  // Card, CardContent, Chip,
  Stack, Divider, Grid, Pagination, Tab, Tabs, tabsClasses,
} from '@mui/material';
// import TopPost from '../src/components/BlogPost/TopBlogs'
import getBlogs from '../../lib/blogs/_getBlogs'
import { useState } from 'react'
import { styled } from '@mui/material/styles';
import SearchBlog from '../../src/components/_common/SearchBlog';
import { dataConstants } from '../../src/constants';
// import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import { getRandomStr } from '../../src/helpers';
import getPageMetaTags from '../../lib/meta/_getMetaTags';
import getStockTabs from '../../lib/stock/_getStockTabsData';

const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  minHeight: '25px',
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  '& .MuiTabs-indicatorSpan': {
    maxWidth: 40,
    width: '100%',
    // backgroundColor: '#635ee7',
  },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: 'capitalize',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    color: 'rgba(2, 11, 74, 0.7)',
    minHeight: '25px',
    minWidth: '55px',
    padding: '3px 16px',
    borderRadius: '5px',
    backgroundColor: '#E7EBF0',
    '&.Mui-selected': {
      color: '#fff',
      backgroundColor: '#2a2d64',
      border: '1px solid rgba(255, 255, 255, 0.15)',
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'rgba(100, 95, 228, 0.32)',
    },
  }),
);

const ListItem = styled('li')(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

const handleTags = (e) => {
  let arr = []
  e.map(d => d?.frontmatter?.tags && arr.push(...d?.frontmatter?.tags))
  return arr
}

export default function Blogs({ posts: blogs, hero }) {
  // const [chipData, setChipData] = useState([
  //   { key: 0, label: 'January' },
  //   { key: 1, label: 'Earnings' },
  //   { key: 2, label: 'Yield Curve' },
  //   { key: 3, label: 'Undervalued' },
  //   { key: 4, label: 'Retail Sale' },
  //   { key: 5, label: '5 min read' },
  //   { key: 6, label: '2 min read' },
  // ]);

  const [posts, setPosts] = useState(blogs);
  const [showSearch, setShowSearch] = useState(false);
  const [filter, setFilter] = useState(false);
  const [filteredTag, setFilteredTag] = useState(null);
  const [filterTags, setFilterTags] = useState(handleTags(blogs)?.filter((v, i, a) => a.indexOf(v) === i));
  const [page, setPage] = useState(1);
  const [value, setValue] = useState(0);
  const ROWS_PER_PAGE = 20;

  const handleFilterChange = (event, newValue) => {
    setValue(newValue);
    if (newValue <= 0) {
      handleDelete()
    } else {
      filterByTag(event?.target?.textContent)
    }
  };

  // const count = Math.ceil(posts.slice(filter ? 0 : dataConstants.TOP_TWO_BLOGS).length / ROWS_PER_PAGE);
  // const _POSTS = usePagination(posts.slice(filter ? 0 : dataConstants.TOP_TWO_BLOGS), ROWS_PER_PAGE);
  const count = Math.ceil(posts.length / ROWS_PER_PAGE);
  const _POSTS = usePagination(posts, ROWS_PER_PAGE);

  const handlePaginationChange = (e, p) => {
    let elmntToView = document.getElementById("all-posts");
    elmntToView.scrollIntoView();
    setPage(p);
    _POSTS.jump(p);
  };

  const filterByTag = (filter) => {
    let elmntToView = document.getElementById("all-posts");
    elmntToView.scrollIntoView();

    // setPosts(blogs.filter(d => filters.every(filter => d.slug.includes(filter))))
    setPosts(blogs.filter(d => d?.frontmatter?.tags && d?.frontmatter?.tags.find(d => d === filter)))
    setFilter(true)
    _POSTS.jump(1);
    setPage(1);
    setFilteredTag(`tagged as <span class="filtered-tag">"${filter}"<span>`)
  }

  const handleDelete = () => {
    setPosts(blogs)
    setFilter(false)
    setFilteredTag(null)
  };

  return (
    <>
      <Box
        sx={{
          // background: 'linear-gradient(180deg, #F3F6F9 0%, #FFFFFF 100%)',
          display: { md: 'block', xs: 'none' }
        }}>
        <Container maxWidth="lg" sx={{}}>
          <Box sx={{ pt: 7, pb: 0, textAlign: 'center' }}>
            <Typography variant="h1" sx={{ fontWeight: 500, color: '#000', fontSize: '1.5rem' }}>{hero?.h1 ?? `Insightful Market Blogs`}</Typography>
            <Typography variant='h1' component="p" sx={{ fontSize: '.9rem', color: 'text.very_light_desc', my: 1 }}>{hero?.desc ?? `Stay informed with our insightful market blogs and analysis.`}</Typography>
            {/* <Typography variant="h2" sx={{ fontWeight: 600, fontSize: '2.125rem' }}>
              Latest Financial Blogs on&nbsp;
              <Typography variant="span" sx={{
                background: 'linear-gradient(to right, #2DA1EE, #174c86)',
                '-webkit-background-clip': 'text',
                '-webkit-text-fill-color': 'transparent',
              }}>
                Trending Topics.
              </Typography>
            </Typography> */}
          </Box>
          {/* <Box component="div" sx={{ mt: 2, pb: 10 }}>
            <TopPost
              posts={blogs}
            />
          </Box> */}
        </Container>
      </Box >
      <Box component="div" sx={{ background: '#fff' }}>
        <Container maxWidth="lg" sx={{}}>
          <Divider id="all-posts" sx={{ mb: { md: 9, xs: 3 }, borderColor: 'transparent' }} />
          <Box component="div" sx={{ display: 'flex', flexDirection: { md: 'row', xs: 'column' }, alignItems: { md: 'center', sm: 'start', xs: 'start' }, }}>
            <Typography variant="h5" sx={{ fontWeight: 500, '& .filtered-tag': { color: '#174c86', textTransform: 'capitalize' } }}>Posts&nbsp;
              <Typography variant="span"
                dangerouslySetInnerHTML={{ __html: filteredTag }}
              />
            </Typography>
            <Box component="div" sx={{ bgcolor: 'primary.main', m: { xs: '0 auto', md: '0 0 0 auto' }, width: { md: '43ch', xs: '100%' }, borderRadius: '8px', mt: { xs: 4, md: 0 } }}>
              <SearchBlog setShowSearch={setShowSearch} posts={posts} placeholder="Search blogs..." />
            </Box>
          </Box>
          {filterTags && filterTags.length > 0 ?
            <Box sx={{
              bgcolor: '#fff', position: 'sticky', top: '3rem', pt: 3, pb: 1.5, zIndex: 10,
              '& .MuiTabs-root .MuiTabs-scrollButtons': {
                position: 'absolute',
                py: .4,
                opacity: 1,
                zIndex: 99,
              },
              '& .MuiTabs-root .MuiTabs-scrollButtons.Mui-disabled': { display: 'none' },
              '& .MuiTabs-root .MuiTabScrollButton-root:first-child': {
                left: 0,
                background: 'linear-gradient(to right, rgb(255, 255, 255) 37%,rgba(33,33,33,0) 97%)',
                justifyContent: 'flex-start',
                width: '75px',
              },
              '& .MuiTabs-root .MuiTabScrollButton-root:last-child': {
                right: 0,
                background: 'linear-gradient(to left, rgb(255, 255, 255) 37%,rgba(33,33,33,0) 97%)',
                justifyContent: 'flex-end',
                width: '75px',
              }
            }}>
              <StyledTabs
                value={value}
                onChange={handleFilterChange}
                variant="scrollable"
                scrollButtons
                allowScrollButtonsMobile
                aria-label="scrollable blog filters"
                sx={{
                  [`& .${tabsClasses.scrollButtons}`]: {
                    '&.Mui-disabled': { opacity: 0.3 },
                  },
                }}
              >
                <StyledTab label="All" />
                {filterTags.map((d) => {
                  return (<StyledTab key={getRandomStr(3)} label={d} />);
                })}
              </StyledTabs>
            </Box> : null}
          <Box sx={{ my: 5 }}>
            <Grid container spacing={1.2} direction={{ sm: "row-reverse" }}>
              {/* <Grid size={{ md: 4, xs: 12 }} sx={{ display: { md: 'block', xs: 'none' } }}>
                <Card variant="outlined" sx={{ borderRadius: '8px', position: 'sticky', top: '100px' }}>
                  <CardContent>
                    <Typography variant="h6" component="div" sx={{ mt: 1, fontSize: '1rem', '& a': { color: '#000', textDecoration: 'none' }, '& a:hover': { color: 'text.link', textDecoration: 'underline' } }}>
                      Filter by tag
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        listStyle: 'none',
                        p: 0.5,
                        my: 2,
                      }}
                      component="ul"
                    >
                      {filterTags.map((d) => {

                        return (
                          <ListItem key={getRandomStr(3)}>
                            {filteredTag?.includes(d) ?
                              <Chip
                                // onClick={() => filterByTag([d])}
                                onClick={() => filterByTag(d)}
                                onDelete={handleDelete}
                                deleteIcon={<CancelRoundedIcon />}
                                label={d} size="small"
                                sx={{ color: '#174c86', textTransform: 'capitalize', bgcolor: '#E7EBF0', fontWeight: 600 }} /> :
                              <Chip
                                // onClick={() => filterByTag([d])}
                                onClick={() => filterByTag(d)}
                                label={d} size="small" variant="outlined"
                                sx={{ color: '#3E5060', textTransform: 'capitalize', bgcolor: filteredTag?.includes(d) ? '#E7EBF0' : '' }} />}
                          </ListItem>);
                      })}
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
              <Grid size={{ md: 1, xs: 12 }} /> */}
              <Grid size={{ md: 12, xs: 12 }}>
                <Stack
                  spacing={1}
                  divider={<Divider />}
                  sx={{
                    // '& .premium-blog': { position: 'relative' },
                    // '& .premium-blog:after': {
                    //   content: "''",
                    //   top: 0,
                    //   transform: 'translateX(100%)',
                    //   width: '100%',
                    //   height: '220px',
                    //   position: 'absolute',
                    //   zIndex: 1,
                    //   animation: 'slide 2s infinite',
                    //   animationDelay: '0s',
                    //   background: 'linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(255,255,255,0.8) 50%,rgba(128,186,232,0) 99%,rgba(125,185,232,0) 100%)'
                    // }
                  }}
                >
                  {_POSTS.currentData().map((post, index) => (
                    <Post key={index} post={post} index={index} />
                  ))}
                </Stack>
                <Box component="div" sx={{ my: 7 }}>
                  <Pagination
                    sx={{
                      '& .MuiPaginationItem-root.Mui-selected': {
                        border: '1px solid #174c86 !important',
                        color: '#174c86',
                        background: '#174c8629 !important'
                      },
                      '& .MuiPaginationItem-ellipsis': {
                        border: '0 !important'
                      },
                      '& .MuiPaginationItem-root': {
                        border: ' 1px solid rgba(0 0 0 / 0.23)',
                        fontWeight: 600
                      },
                      '& .MuiPagination-ul': {
                        justifyContent: 'center'
                      }
                    }}
                    count={count}
                    page={page}
                    onChange={handlePaginationChange}
                    variant="outlined"
                    shape="rounded"
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Box>
    </>
  )
}

export async function getStaticProps() {
  const { getBlogs: blogs } = (await getBlogs()) || {}
  const hero_data = (await getStockTabs("AAPL", "HERO")) || [];
  const { getStockTabs: hero } = hero_data || {};
  const meta_tags = (await getPageMetaTags('/blogs', false)) || {}
  const { getMetaTags } = meta_tags || {}

  // Get slug and frontmatter from posts
  const posts = blogs.map((blog) => {
    const { data: frontmatter } = matter(blog?.content)

    return {
      slug: blog?.urlsuffix,
      frontmatter,
    }
  })

  return {
    props: {
      posts: posts.sort(sortByDate),
      hero: getHeroContent(hero, "blogs") || {},
      meta_tags: getMetaTags?.tags || null
    },
    revalidate: dataConstants.REVALIDATE_IN.SIX_HOURS,
    // notFound: process.env.NODE_ENV !== 'production' ? false : true,
  }
}
